import React from 'react'
import Table from 'UI/Table';
import LocationsTable from './LocationsTable';

const DataProtectionConsumptionReport = ({ clients }) => (
  <Table
    filterable
    defaultSorted={[{ id: "name", desc: false }]}
    data={clients}
    columns={[
      { Header: 'Name', accessor: 'name'  },
      { Header: 'Data Written', accessor: 'data_written_in_bytes', Cell: row => row.original.data_written },
      { Header: 'Non-Aged Data Written', accessor: 'non_aged_data_written_in_bytes', Cell: row => row.original.non_aged_data_written },
      { Header: 'Job Count', accessor: 'job_count', Cell: ({ value }) => parseInt(value).toLocaleString() }
    ]}
    SubComponent={({ original: { locations } }) => <LocationsTable {...{ locations }} />}
  />
)

export default DataProtectionConsumptionReport
